<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 11:04:23
 * @LastEditTime: 2025-10-16 14:05:51
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-operate">
    <div class="c-operate__item">
      <IconByTooltip
        :data="{ ...copyData, icon: 'copyIcon', label: '复制' }"
        :copyValue="dataProp.content[0].value"
        class="iconfont_wrap"
        @on-change="
          (e) => {
            copyData.isCopy = false;
            copyData.className = 'iconfont icon-a-fuzhimoren';
          }
        "
        @on-click="
          () => {
            copyData.isCopy = true;
            copyData.className = 'iconfont icon-a-yifuzhimoren';
          }
        "
      ></IconByTooltip>
    </div>
  </div>
</template>

<script>
import IconByTooltip from "@/components/aiChat/components/compose/iconByTooltip.vue";

export default {
  components: {
    IconByTooltip,
  },
  props: {
    dataProp: {
      type: Object,
      default() {
        return {};
      },
    },
    formModalDataProp: {
      type: Object,
      default() {
        return {};
      },
    },
    indexProp: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      copyData: {},
      isLoading: false,
    };
  },
  watch: {
    dataProp: {
      handler: function (n) {
        console.log(n, "rrrrr");
        this.copyData = JSON.parse(JSON.stringify({ ...n.copyData }));
        // this.isLoading = fetchEventSourceManager.onGetLoading();
      },
      immediate: true,
    },
    copyData: {
      handler: function (n) {
        console.log(n, "tttt");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-operate {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .c-operate__item {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    > i {
      font-size: 16px;
      padding: 2px 4px;
      color: #86909c;
      cursor: pointer;
    }
    ::v-deep .icon_class_wrap {
      &:hover {
        background: #e8f3ff;
        border-radius: 8px;
        .i-class_name {
          color: #165dff;
        }
      }
    }
    &.delete_wrap {
      ::v-deep .icon_class_wrap {
        &:hover {
          background-color: rgba(245, 63, 63, 0.1);
          border-radius: 8px;
          .i-class_name {
            color: #f53f3f;
          }
        }
      }
    }
    &:last-child {
      margin-right: 0;
    }

    .iconfont_wrap {
      ::v-deep .icon_class_wrap {
        padding: 4px;
        height: 24px;
      }
    }
  }
}
</style>